module.exports = __webpack_public_path__ + "static/img/header2.0009cf1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header2.jpg
// module id = 921z
// module chunks = 1